import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'

//plugins
import { Modal, Button, Tabs, Tab, FloatingLabel, Form, Row, Col, Alert } from 'react-bootstrap';
import { TextCenter, TextLeft, TextRight, TrashFill } from 'react-bootstrap-icons';
import { PDFReader } from 'reactjs-pdf-reader'

//helpers
import Api from 'helpers/Api'
import { useValidation } from 'helpers/Validation'
import { useNestedState } from 'helpers/NestedState'

//providers
import { useLanguageContext } from 'providers/Language'

//misc
import SaveButton from 'components/misc/Button'
import Info from 'components/modals/Info';
import Autocomplete from 'components/misc/Autocomplete';

import barcodeImage from 'assets/img/barcode.gif';
// import logoImage from 'assets/img/logo.svg';
// import noImage from 'assets/img/no-image.png';

import './style.scss';

import { buildUrl } from 'helpers/Url';

const logoImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAABICAMAAACDWFYkAAAAS1BMVEX///8AAABpaWlycnLn5+dqamrm5uZVVVUuLi7MzMzi4uLf39+VlZV8fHx4eHh2dnaxsbHNzc0tLS1iYmJdXV24uLilpaWnp6empqZy8p+9AAAB2UlEQVRIx82Xja7bIAyFcRr8s3kD0t67vf+TDjNFadASB0WT7mlDoOWTD9g0avjaek1TbO/aROvZK66jJhu/3pApXFLcIZ/xp6P42SHP8s2RPMO0Qx6z52p+hDiI4B6JQ1HuIyhSpGnGHjlYPsGbOOUuiosYpa4xgl56aAzfkFRFtNL5wlp4zYRw84Z+FN7SR5s1PI+yMYbQVWP92JDDHVv+iWCHnEaBLi8OwjYeW0tL0w7xoiRDdMSYgGm+jKAybL4CniImWEVdWfqVTKPFz3rxVHITqUp39r28bBqq5HtRbC33kPif1jKEHBwxHNyxDUlElAaMbfKROI5Md5AiEoJs2yQiDiKQiIXr3GSzki60JNydyh4pHBA+DAENSElThfU0SlkwgyyGkFIyJAidnkoBptKMMTJJQ3I6rTHh1iBidRgqQkVBzo0la4joIxmruXpDLy/jz31Bs10110sE0UUQsu1BU8rWcnKMGWJSqE2GLJlhOS3LHhErA9CDXxg8QCypI8aK9ZnGjFUdPsXw7+c9Yt3sRFEp5W3HlIC8Ta7iFWkD9U4l4jxj/d7M7LOPIzV2qyzvRnnKd0fy7JDfjx+OHr86xFU/7TVt/3CsZ+16r5fdrX2FL60/qW8aWT2gkDQAAAAASUVORK5CYII=';
const noImage = 'data:image/png;base64,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';

const areaScale = 7;
const fontSizeScale = 1.33333333 * 1.83;

// 'article_id' => 'ID на артикул',
// 'article_name' => 'Име на артикул',
// 'article_name_public' => 'Публично име на артикул',
// 'barcode' => 'Баркод',
// 'code' => 'Код за бързо избиране',
// 'actual_price' => 'Базова цена',
// 'current_price' => 'Текуща цена',
// 'base_discount' => 'Намаление(%)',
// 'amount_unit' => 'Ед. продажба',
// 'amount_type_name_short' => 'Тип количество кратко',
// 'amount_type_name' => 'Тип количество дълго',
// 'ref_num' => 'Референтен номер',
// 'text' => 'Свободен текст',
// 'logo' => 'Лого',
// 'article_details' => 'Характеристика',
// 'supplier_name' => 'Доставчик',
// 'cat_name' => 'Категория',
// 'image' => 'Изображение',
// 'print_date' => 'Дата при отпечатване',

const baseElements = {
    article_id: {
        name: 'ID на артикул',
        type: 'text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "article_id",
            size: 10,
            value: "1234",
            x: 10,
            y: 10
        },
    },
    article_name: {
        name: 'Име на артикул',
        type: 'text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "article_name",
            size: 10,
            value: "Име на артикул",
            x: 10,
            y: 10
        },
    },
    article_name_public: {
        name: 'Публично име',
        type: 'text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "article_name_public",
            size: 10,
            value: "Публично име",
            x: 10,
            y: 10
        },
    },
    barcode: {
        name: 'Баркод',
        type: 'barcode',
        props: {
            name: "barcode",
            barcode_type: 'ean13',
            width: 30,
            height: 14,
            value: "1234",
            x: 10,
            y: 10
        },
    },
    code: {
        name: 'Код за бързо избиране',
        type: 'text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "code",
            size: 10,
            value: "[Код]",
            x: 10,
            y: 10
        },
    },
    actual_price: {
        name: 'Базова цена',
        type: 'price',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "actual_price",
            size: 10,
            value: "99.99",
            prefix: "Цена: ",
            sufix: "лв",
            x: 10,
            y: 10
        },
    },
    current_price: {
        name: 'Текуща цена',
        type: 'price',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "current_price",
            size: 10,
            value: "99.99",
            prefix: "Цена: ",
            sufix: "лв",
            x: 10,
            y: 10
        },
    },
    base_discount: {
        name: 'Намаление(%)',
        type: 'price',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "base_discount",
            size: 10,
            value: "-50",
            prefix: "Намаление: ",
            sufix: "%",
            x: 10,
            y: 10
        },
    },
    amount_unit: {
        name: 'Ед. продажба',
        type: 'text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "amount_unit",
            size: 10,
            value: "1",
            x: 10,
            y: 10
        },
    },
    amount_type_name_short: {
        name: 'Тип количество (кратко)',
        type: 'text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "amount_type_name_short",
            size: 10,
            value: "бр",
            x: 10,
            y: 10
        },
    },
    amount_type_name: {
        name: 'Тип количество (дълго)',
        type: 'text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "amount_type_name",
            size: 10,
            value: "брой",
            x: 10,
            y: 10
        },
    },
    ref_num: {
        name: 'Референтен номер',
        type: 'text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "ref_num",
            size: 10,
            value: "RFC 222-10",
            x: 10,
            y: 10
        },
    },
    text: {
        name: 'Свободен текст',
        type: 'free-text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "text",
            size: 10,
            value: "Текст",
            x: 10,
            y: 10
        },
    },
    logo: {
        name: 'Лого',
        type: 'logo',
        props: {
            name: "logo",
            width: 20,
            height: 20,
            value: logoImage,
            x: 10,
            y: 10
        },
    },
    article_details: {
        name: 'Характеристика',
        type: 'article_details',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "article_details",
            size: 10,
            value: "Характеристика",
            x: 10,
            y: 10
        },
    },
    supplier_name: {
        name: 'Доставчик',
        type: 'text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "supplier_name",
            size: 10,
            value: "[доставчик]",
            x: 10,
            y: 10
        },
    },
    cat_name: {
        name: 'Категория',
        type: 'text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "cat_name",
            size: 10,
            value: "[категория]",
            x: 10,
            y: 10
        },
    },
    image: {
        name: 'Изображение',
        type: 'image',
        props: {
            name: "image",
            width: 20,
            height: 20,
            value: noImage,
            x: 10,
            y: 10
        },
    },
    print_date: {
        name: 'Дата при отпечатване',
        type: 'free-text',
        props: {
            align_center: 0,
            bold: 0,
            italic: 0,
            linetrough: 0,
            underline: 0,
            name: "print_date",
            size: 10,
            value: "d.m.Y H:i:s",
            x: 10,
            y: 10
        },
    },
};

const fontSizes = [
    4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 50, 60, 70, 80, 90, 100
];

let timeout;

function AddOrEdit(props, ref) {

    const defaultData = {
        page_width: 210,
        page_height: 297,
        left_margin: 3,
        top_margin: 2,
        w: 70,
        h: 36,
        x_space: 0,
        elements: [],
    }

    const [state, setState] = useNestedState({
        show: false,
        id: null,
        edit: false,
        data: defaultData,
        loading: false,
        refreshPreview: false,
        grid: false,
        onSuccess: null,
        onEntering: null,
        onExiting: null
    });

    const [activeElement, setActiveElement] = useState(null);

    const [elements, setElements] = useState([]);

    const [validations, setValidations] = useValidation();

    const areaRef = useRef(null);
    const inputFileRef = useRef(null);

    useImperativeHandle(ref, () => ({
        add: () => {
            handleShow();
        },
        edit: (id) => {
            edit(id);
        },
        hide: () => {
            hide();
        },
        onSuccess: fn => {
            setState(prev => ({
                ...prev,
                onSuccess: fn
            }));
        }
    }));

    useEffect(() => {
        loadData();
    }, [state.edit]);

    useEffect(() => {
        Api.get('labels/elements')
            .then(res => {
                setElements(res.data.elements);
            });
    }, []);

    useEffect(() => {
        clearTimeout(timeout);

        timeout = setTimeout(() => {
            loadPreview();
        }, 1300);

    }, [state.refreshPreview]);

    const show = (onEntering = null) => {
        setState(prev => ({
            ...prev,
            show: true,
            onEntering: onEntering,
        }));
    }

    const hide = (onExiting = null) => {
        setState(prev => ({
            ...prev,
            show: false,
            onExiting: onExiting
        }));
    }

    const handleShow = () => {
        setState(prev => ({
            ...prev,
            data: defaultData,
            id: null,
        }));
        show();
    }

    const handleClose = e => {

        if (e) {
            e.preventDefault();
        }

        setState(prev => ({
            ...prev,
            data: defaultData,
            id: null,
        }));

        setValidations(null);

        hide();
    }

    const edit = id => {
        setState(prev => ({
            ...prev,
            id: id,
            edit: new Date().getTime()
        }));

        show();
    }

    const loadData = () => {
        if (!state.id) {
            return;
        }

        Api.get('labels/show?id=' + state.id)
            .then(res => {
                let data = res.data;

                if (!Array.isArray(data.elements)) {
                    data.elements = []
                }

                setState(prev => ({
                    ...prev,
                    data: data
                }))
            });
    }

    const loadPreview = () => {
        if (!state.show) {
            return;
        }

        Api.post('/labels/preview', state.data)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    preview: res.data.data
                }))
            });
    }

    const handleSave = e => {
        e.preventDefault();

        setState(prev => ({
            ...prev,
            loading: true,
        }));

        setValidations(null);

        let url = state.id ? 'labels/edit' : 'labels/add';

        let data = JSON.stringify(state.data);

        Api.post(url, data, {
            headers: {
                'content-type': 'application/json'
            }
        }).then(res => {
            if (typeof state.onSuccess === 'function') {
                state.onSuccess(res.data)
            }

            hide()
        }).catch(error => {
            const _err = error.response;

            if (_err && _err.status && _err.status === 422) {
                setValidations(_err.data.errors);
            }

        }).finally(() => {
            setState(prev => ({
                ...prev,
                loading: false,
            }));
        });
    }

    const handleInputChange = e => {
        const name = e.target.name
        const value = e.target.value

        setState(name, value, 'data')
    }

    const handleDateChange = e => {
        const name = e.target.name + '_ymd'
        const value = e.target.value

        setState(name, value, 'data')
    }

    const getAreaWidth = () => {
        let labelWidth = getLabelWidth();

        let areaWidth = labelWidth * areaScale;

        return areaWidth;
    }

    const getAreaHeight = () => {
        let labelHeight = getLabelHeight();

        let areaHeight = labelHeight * areaScale;

        return areaHeight;
    }

    const getLabelWidth = () => {
        return state.data.w;
    }

    const getLabelHeight = () => {
        return state.data.h;
    }

    const getLabelWidthInPx = () => {
        return getLabelWidth() * 3.7795275591;
    }

    const getLabelHeightInPx = () => {
        return getLabelHeight() * 3.7795275591;
    }

    const insertElement = (id) => {
        let element = baseElements[id];

        if (!element) {
            console.error('Не е дефиниран елемент с ID ' + id);
            return;
        }

        let length = state.data.elements.length;

        setState(prev => ({
            ...prev,
            data: {
                ...prev.data,
                elements: prev.data.elements.concat(element.props)
            }
        }));

        setActiveElement(length);
    }

    const removeElement = index => {
        setState(prev => ({
            ...prev,
            data: {
                ...prev.data,
                elements: prev.data.elements.filter((e, i) => i !== index)
            }
        }));
    }

    const removeActiveElement = () => {
        removeElement(activeElement);
        setActiveElement(null);
    }

    const getElementX = (element) => {
        return Math.round((element.x * getAreaWidth()) / getLabelWidth());
    }

    const getElementY = (element) => {
        return Math.round((element.y * getAreaHeight()) / getLabelHeight());
    }

    const setActiveElementPos = (pos, value) => {
        if (pos === 'x') {
            setActiveElementValue(pos, (Number(value) / getAreaWidth()) * getLabelWidth());
        } else if (pos === 'y') {
            setActiveElementValue(pos, (Number(value) / getAreaHeight()) * getLabelHeight());
        }
    }

    const setActiveElementValue = (key, value) => {
        setState(prev => ({
            ...prev,
            data: {
                ...prev.data,
                elements: Object.values({
                    ...prev.data.elements,
                    [activeElement]: {
                        ...prev.data.elements[activeElement],
                        [key]: value
                    }
                })
            }
        }))
    }

    const setActiveElementAlign = (key, value) => {
        let left = key === 'left' ? value : 0;
        let center = key === 'center' ? value : 0;
        let right = key === 'right' ? value : 0;

        let element = areaRef.current.querySelectorAll('.element')[activeElement].getBoundingClientRect();
        let viewport = areaRef.current.getBoundingClientRect();

        // console.log(element);
        // console.log(viewport);

        let x;

        if (key === 'left') {
            x = 0;
        } else if (key === 'center') {
            x = viewport.width / 2 - element.width / 2;
        } else if (key === 'right') {
            x = viewport.width - element.width;
        }

        x = (Number(x) / getAreaWidth()) * getLabelWidth();

        setState(prev => ({
            ...prev,
            data: {
                ...prev.data,
                elements: Object.values({
                    ...prev.data.elements,
                    [activeElement]: {
                        ...prev.data.elements[activeElement],
                        left: left,
                        center: center,
                        right: right,
                        x: Number(x)
                    }
                })
            }
        }))
    }

    const onClick = (e, index) => {
        e.preventDefault();

        setActiveElement(index);
    }

    const onMouseDown = (e, index) => {
        e.preventDefault();

        let elmnt = e.currentTarget;

        let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

        let rect = elmnt.getBoundingClientRect();
        let viewport = areaRef.current.getBoundingClientRect();

        // console.log(viewport);

        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;

        document.onmouseup = closeDragElement;

        // call a function whenever the cursor moves:
        document.onmousemove = e => {
            e = e || window.event;

            e.preventDefault();

            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;

            let y = (elmnt.offsetTop - pos2);
            let x = (elmnt.offsetLeft - pos1);

            if (x < 0 || y < 0 || x + rect.width > viewport.width || y + rect.height > viewport.height) {
                return;
            }

            // set the element's new position:
            elmnt.style.top = y + "px";
            elmnt.style.left = x + "px";
        };

    }

    const onMouseUp = (e, index) => {
        // console.log(e.currentTarget)

        let y = e.currentTarget.offsetTop;
        let x = e.currentTarget.offsetLeft;

        if (state.grid) {
            y = Math.floor(y / 5) * 5;
            x = Math.floor(x / 5) * 5;
        }

        y = (y / getAreaHeight()) * getLabelHeight();
        x = (x / getAreaWidth()) * getLabelWidth();

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                data: {
                    ...prev.data,
                    elements: Object.values({
                        ...prev.data.elements,
                        [index]: {
                            ...prev.data.elements[index],
                            x: x,
                            y: y,
                        }
                    })
                }
            }))
        }, 0);
    }

    const closeDragElement = () => {
        document.onmouseup = null;
        document.onmousemove = null;
    }

    const getActiveElement = () => {
        return state.data.elements[activeElement];
    }

    const getActiveBaseElement = () => {
        let element = getActiveElement();

        if (!element) {
            return;
        }

        let base = baseElements[element.name];

        return base;
    }

    const getActiveElementType = () => {
        let base = getActiveBaseElement();

        if (!base) {
            return;
        }

        return base.name;
    }

    const getElementValue = element => {

        if (element.name === 'barcode') {
            return <img src={barcodeImage} width={element.width * areaScale} height={element.height * areaScale} />
        }

        if (element.name === 'logo') {
            return <img src={element.value} width={element.width * areaScale} height={element.height * areaScale} />
        }

        if (element.name === 'image') {
            return <img src={element.value} width={element.width * areaScale} height={element.height * areaScale} />
        }

        let value = [];

        if (element.prefix) {
            value.push(element.prefix);
        }

        value.push(element.value);

        if (element.sufix) {
            value.push(element.sufix);
        }

        return value.join('');
    }

    const hasTextButtons = () => {
        let base = getActiveBaseElement();

        if (!base) {
            return;
        }

        return base.type === 'text' || base.type === 'price' || base.type === 'free-text' || base.type === 'article_details';
    }

    const isPrice = () => {
        let base = getActiveBaseElement();

        if (!base) {
            return;
        }

        return base.type === 'price';
    }

    const isBarcode = () => {
        let base = getActiveBaseElement();

        if (!base) {
            return;
        }

        return base.type === 'barcode';
    }

    const isFreeText = () => {
        let base = getActiveBaseElement();

        if (!base) {
            return;
        }

        return base.type === 'free-text';
    }

    const isLogo = () => {
        let base = getActiveBaseElement();

        if (!base) {
            return;
        }

        return base.type === 'logo';
    }

    const isArticleDetail = () => {
        let base = getActiveBaseElement();

        if (!base) {
            return;
        }

        return base.type === 'article_details';
    }

    const isImage = () => {
        let base = getActiveBaseElement();

        if (!base) {
            return;
        }

        return base.type === 'image';
    }

    const handleAttach = e => {
        e.preventDefault();

        inputFileRef.current.click();
    }

    const handleAttachImage = e => {
        let file = e.target.files[0];

        if (!file) {
            return;
        }

        // console.log(file);

        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = function () {
            setActiveElementValue('value', reader.result);
        };

        reader.onerror = function (error) {
            console.log(error);
        };
    }

    const getPreviewSrc = (type) => {
        let url = buildUrl(process.env.REACT_APP_URL + '/api/labels/preview/' + type, {
            data: JSON.stringify(state.data)
        });

        // console.log(url);

        return url;
    }

    const toggleGrid = () => {
        setState(prev => ({
            ...prev,
            grid: !prev.grid
        }));
    }

    // console.log(state.data);

    return (
        <>
            <Modal size="lg" centered show={state.show} onHide={handleClose} onEntering={state.onEntering} onExiting={state.onExiting}>
                <form onSubmit={handleSave}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Етикет {state.data.id ? `(ID: ${state.data.id})` : ''}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Tabs
                            defaultActiveKey="main"
                            className="mb-3"
                            transition={false}
                        >
                            <Tab eventKey="main" title="Основни" tabClassName={""}>
                                <Row>
                                    <Col className="mb-3">
                                        <FloatingLabel label="Име на шаблона">
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={state.data.name || ''}
                                                placeholder="Име на шаблона"
                                                onChange={(e) => handleInputChange(e)}
                                                isInvalid={Boolean(validations && validations.name)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {validations?.name && (validations.name[0] || validations.name)}
                                            </Form.Control.Feedback>
                                        </FloatingLabel>
                                    </Col>
                                    <Col className="mb-3">
                                        <FloatingLabel label="Кол. множител">
                                            <Form.Control
                                                type="number"
                                                step="0.01"
                                                name="multiplier"
                                                value={state.data.multiplier || ''}
                                                placeholder="Кол. множител"
                                                onChange={(e) => handleInputChange(e)}
                                                isInvalid={Boolean(validations && validations.multiplier)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {validations?.multiplier && (validations.multiplier[0] || validations.multiplier)}
                                            </Form.Control.Feedback>
                                        </FloatingLabel>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col>
                                        <FloatingLabel label="Описание">
                                            <Form.Control
                                                as="textarea"
                                                type="text"
                                                name="description"
                                                value={state.data.description || ''}
                                                placeholder="Описание"
                                                onChange={(e) => handleInputChange(e)}
                                                isInvalid={Boolean(validations && validations.description)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {validations?.description && (validations.description[0] || validations.description)}
                                            </Form.Control.Feedback>
                                        </FloatingLabel>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col>
                                        <FloatingLabel label="Добави елемент">
                                            <Form.Select
                                                name="company_id"
                                                value=""
                                                onChange={e => insertElement(e.target.value)}
                                            >
                                                <option value="" selected>Избери елемент</option>
                                                {Object.entries(elements).map(element =>
                                                    <option key={element[0]} value={element[0]}>{element[1]}</option>
                                                )}
                                            </Form.Select>

                                        </FloatingLabel>
                                    </Col>
                                </Row>
                                {getActiveElement() &&
                                    <Row className="mb-3">
                                        <Col>
                                            <div className="active-element">
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <label>
                                                        Тип елемент: {getActiveElementType()}
                                                    </label>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <Form.Control size="sm" type="number" step="1" value={getElementX(getActiveElement())} onChange={e => setActiveElementPos('x', e.target.value)} style={{ width: '70px' }} />
                                                            <span style={{ margin: '0 3px' }}>x</span>
                                                            <Form.Control size="sm" type="number" step="1" value={getElementY(getActiveElement())} onChange={e => setActiveElementPos('y', e.target.value)} style={{ width: '70px' }} />
                                                        </div>
                                                        <Button size="sm" variant="danger" onClick={removeActiveElement} style={{ marginLeft: '10px' }}>
                                                            <TrashFill />
                                                        </Button>
                                                    </div>
                                                </div>
                                                {hasTextButtons() &&
                                                    <div className="buttons left" style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                                                        <Button
                                                            size="sm"
                                                            className={`bold ${getActiveElement().bold ? 'active' : ''}`}
                                                            onClick={e => setActiveElementValue('bold', getActiveElement().bold ? 0 : 1)}
                                                        >
                                                            B
                                                        </Button>
                                                        <Button
                                                            size="sm"
                                                            className={`italic ${getActiveElement().italic ? 'active' : ''}`}
                                                            onClick={e => setActiveElementValue('italic', getActiveElement().italic ? 0 : 1)}
                                                        >
                                                            I
                                                        </Button>
                                                        <Button
                                                            size="sm"
                                                            className={`underline ${getActiveElement().underline ? 'active' : ''}`}
                                                            onClick={e => setActiveElementValue('underline', getActiveElement().underline ? 0 : 1)}
                                                        >
                                                            U
                                                        </Button>
                                                        <Button
                                                            size="sm"
                                                            className={`line-through ${getActiveElement().linetrough ? 'active' : ''}`}
                                                            onClick={e => setActiveElementValue('linetrough', getActiveElement().linetrough ? 0 : 1)}
                                                        >
                                                            AB
                                                        </Button>
                                                        <Button
                                                            size="sm"
                                                            className={`left ${getActiveElement().left ? 'active' : ''}`}
                                                            onClick={e => setActiveElementAlign('left', getActiveElement().left ? 0 : 1)}
                                                        >
                                                            <TextLeft />
                                                        </Button>
                                                        <Button
                                                            size="sm"
                                                            className={`center ${getActiveElement().center ? 'active' : ''}`}
                                                            onClick={e => setActiveElementAlign('center', getActiveElement().center ? 0 : 1)}
                                                        >
                                                            <TextCenter />
                                                        </Button>
                                                        <Button
                                                            size="sm"
                                                            className={`right ${getActiveElement().right ? 'active' : ''}`}
                                                            onClick={e => setActiveElementAlign('right', getActiveElement().right ? 0 : 1)}
                                                        >
                                                            <TextRight />
                                                        </Button>

                                                        <Form.Select
                                                            value={getActiveElement().size}
                                                            onChange={e => setActiveElementValue('size', e.target.value)}
                                                            size="sm"
                                                        >
                                                            {fontSizes.map(o =>
                                                                <option key={o} value={o}>{o}pt</option>
                                                            )}
                                                        </Form.Select>

                                                    </div>
                                                }
                                                {isPrice() &&
                                                    <div className="inputs" style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                                                        <div className="group">
                                                            <label>Префикс</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                value={getActiveElement().prefix}
                                                                onChange={e => setActiveElementValue('prefix', e.target.value)}
                                                                style={{ width: '70px' }}
                                                            />
                                                        </div>
                                                        <div className="group">
                                                            <label>Суфикс</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                value={getActiveElement().sufix}
                                                                onChange={e => setActiveElementValue('sufix', e.target.value)}
                                                                style={{ width: '70px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                {isBarcode() &&
                                                    <div className="inputs" style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                                                        <div className="group">
                                                            <label>Тип</label>
                                                            <Form.Select
                                                                value={getActiveElement().barcode_type}
                                                                onChange={e => setActiveElementValue('barcode_type', e.target.value)}
                                                                size="sm"
                                                            >
                                                                <option value="ean13">EAN-13</option>
                                                                <option value="ean8">EAN-8</option>
                                                                <option value="code128">CODE128</option>
                                                            </Form.Select>
                                                        </div>
                                                        <div className="group">
                                                            <label>Ширина</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="number"
                                                                step="1"
                                                                value={getActiveElement().width}
                                                                onChange={e => setActiveElementValue('width', e.target.value)}
                                                                style={{ width: '70px' }}
                                                            />
                                                        </div>
                                                        <div className="group">
                                                            <label>Височина</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="number"
                                                                step="1"
                                                                value={getActiveElement().height}
                                                                onChange={e => setActiveElementValue('height', e.target.value)}
                                                                style={{ width: '70px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                {isFreeText() &&
                                                    <div className="inputs" style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                                                        <div className="group">
                                                            <label>Стойност</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="text"
                                                                value={getActiveElement().value}
                                                                onChange={e => setActiveElementValue('value', e.target.value)}
                                                            // style={{ width: '70px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                {isLogo() &&
                                                    <div className="inputs" style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                                                        <div className="group">
                                                            <label>Ширина</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="number"
                                                                step="1"
                                                                value={getActiveElement().width}
                                                                onChange={e => setActiveElementValue('width', e.target.value)}
                                                                style={{ width: '70px' }}
                                                            />
                                                        </div>
                                                        <div className="group">
                                                            <label>Височина</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="number"
                                                                step="1"
                                                                value={getActiveElement().height}
                                                                onChange={e => setActiveElementValue('height', e.target.value)}
                                                                style={{ width: '70px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                {isArticleDetail() &&
                                                    <div className="inputs" style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                                                        <div className="group">
                                                            <label>Стойност</label>
                                                            {/* <Form.Control
                                                         size="sm"
                                                         type="number"
                                                         step="1"
                                                         value={getActiveElement().width}
                                                         onChange={e => setActiveElementValue('width', e.target.value)}
                                                         style={{ width: '70px' }}
                                                     /> */}

                                                            <Autocomplete
                                                                variant="basic"
                                                                size="sm"
                                                                url="autocomplete/article-details"
                                                                inputValue={getActiveElement().value || ''}
                                                                onChange={data => setActiveElementValue('value', data.name)}
                                                                onInputChange={data => setActiveElementValue('value', data)}
                                                                renderText={data => data?.translation?.name || data.name}
                                                            />
                                                        </div>

                                                    </div>
                                                }
                                                {isImage() &&
                                                    <div className="inputs" style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
                                                        <div className="group">
                                                            <label>Стойност</label>
                                                            <Button
                                                                size="sm"
                                                                onClick={handleAttach}
                                                            >
                                                                Прикачи
                                                            </Button>
                                                            <input ref={inputFileRef} type="file" accept="image/*" onChange={handleAttachImage} hidden />
                                                        </div>
                                                        <div className="group">
                                                            <label>Ширина</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="number"
                                                                step="1"
                                                                value={getActiveElement().width}
                                                                onChange={e => setActiveElementValue('width', e.target.value)}
                                                                style={{ width: '70px' }}
                                                            />
                                                        </div>
                                                        <div className="group">
                                                            <label>Височина</label>
                                                            <Form.Control
                                                                size="sm"
                                                                type="number"
                                                                step="1"
                                                                value={getActiveElement().height}
                                                                onChange={e => setActiveElementValue('height', e.target.value)}
                                                                style={{ width: '70px' }}
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </Col>
                                    </Row>
                                }
                                <Row>
                                    <Col>
                                        <div className="area-wrapper">
                                            <div className="area" ref={areaRef} style={{
                                                width: getAreaWidth(),
                                                height: getAreaHeight(),
                                                // maxWidth: '100%'
                                            }}>
                                                {state.data.elements.map((element, i) =>
                                                    <div
                                                        key={i}
                                                        className={['element', activeElement === i && 'active'].join(' ')}
                                                        onClick={e => onClick(e, i)}
                                                        onMouseDown={e => onMouseDown(e, i)}
                                                        onMouseUp={e => onMouseUp(e, i)}
                                                        style={{
                                                            top: getElementY(element),
                                                            left: getElementX(element),
                                                            fontSize: element.size * fontSizeScale,
                                                            fontWeight: element.bold ? 'bold' : 'normal',
                                                            fontStyle: element.italic ? 'italic' : 'normal',
                                                            textDecoration: [element.linetrough ? 'line-through' : '', element.underline ? 'underline' : ''].join(' '),
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {getElementValue(element)}
                                                    </div>
                                                )}
                                                {state.grid &&
                                                    <div className="grid"></div>
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="area-wrapper">
                                            <div className="area" style={{
                                                width: getAreaWidth(),
                                                height: getAreaHeight() + 2,
                                                // maxWidth: '100%'
                                            }}>
                                                <PDFReader key={getPreviewSrc('label')} url={getPreviewSrc('label')} width={getAreaWidth() - 2}>asd</PDFReader>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Tab>

                            <Tab eventKey="settings" title="Настройки" tabClassName={""}>
                                <Row className="mb-3">
                                    <Col xs={3} style={{ display: 'flex' }}>
                                        <label style={{ margin: 'auto 0' }}>
                                            Размер лист:
                                        </label>
                                    </Col>
                                    <Col>
                                        <FloatingLabel label="Ширина (mm)">
                                            <Form.Control
                                                type="number"
                                                step="1"
                                                name="page_width"
                                                value={state.data.page_width || ''}
                                                placeholder="Ширина (mm)"
                                                onChange={(e) => handleInputChange(e)}
                                                isInvalid={Boolean(validations && validations.page_width)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {validations?.page_width && (validations.page_width[0] || validations.page_width)}
                                            </Form.Control.Feedback>
                                        </FloatingLabel>
                                    </Col>
                                    <Col>
                                        <FloatingLabel label="Височина (mm)">
                                            <Form.Control
                                                type="number"
                                                step="1"
                                                name="page_height"
                                                value={state.data.page_height || ''}
                                                placeholder="Височина (mm)"
                                                onChange={(e) => handleInputChange(e)}
                                                isInvalid={Boolean(validations && validations.page_height)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {validations?.page_height && (validations.page_height[0] || validations.page_height)}
                                            </Form.Control.Feedback>
                                        </FloatingLabel>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col xs={3} style={{ display: 'flex' }}>
                                        <label style={{ margin: 'auto 0' }}>
                                            Отстъп лист:
                                        </label>
                                    </Col>
                                    <Col>
                                        <FloatingLabel label="Отляво (mm)">
                                            <Form.Control
                                                type="number"
                                                step="1"
                                                name="left_margin"
                                                value={state.data.left_margin || ''}
                                                placeholder="Отляво (mm)"
                                                onChange={(e) => handleInputChange(e)}
                                                isInvalid={Boolean(validations && validations.left_margin)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {validations?.left_margin && (validations.left_margin[0] || validations.left_margin)}
                                            </Form.Control.Feedback>
                                        </FloatingLabel>
                                    </Col>
                                    <Col>
                                        <FloatingLabel label="Отгоре (mm)">
                                            <Form.Control
                                                type="number"
                                                step="1"
                                                name="top_margin"
                                                value={state.data.top_margin || ''}
                                                placeholder="Отгоре (mm)"
                                                onChange={(e) => handleInputChange(e)}
                                                isInvalid={Boolean(validations && validations.top_margin)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {validations?.top_margin && (validations.top_margin[0] || validations.top_margin)}
                                            </Form.Control.Feedback>
                                        </FloatingLabel>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col xs={3} style={{ display: 'flex' }}>
                                        <label style={{ margin: 'auto 0' }}>
                                            Размер етикет:
                                        </label>
                                    </Col>
                                    <Col>
                                        <FloatingLabel label="Ширина (mm)">
                                            <Form.Control
                                                type="number"
                                                step="1"
                                                name="w"
                                                value={state.data.w || ''}
                                                placeholder="Ширина (mm)"
                                                onChange={(e) => handleInputChange(e)}
                                                isInvalid={Boolean(validations && validations.w)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {validations?.w && (validations.w[0] || validations.w)}
                                            </Form.Control.Feedback>
                                        </FloatingLabel>
                                    </Col>
                                    <Col>
                                        <FloatingLabel label="Височина (mm)">
                                            <Form.Control
                                                type="number"
                                                step="1"
                                                name="h"
                                                value={state.data.h || ''}
                                                placeholder="Височина (mm)"
                                                onChange={(e) => handleInputChange(e)}
                                                isInvalid={Boolean(validations && validations.h)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {validations?.h && (validations.h[0] || validations.h)}
                                            </Form.Control.Feedback>
                                        </FloatingLabel>
                                    </Col>
                                </Row>
                                <Row className="mb-3">
                                    <Col xs={3} style={{ display: 'flex' }}>
                                        <label style={{ margin: 'auto 0' }}>
                                            Отстъп етикет:
                                        </label>
                                    </Col>
                                    <Col>
                                        <FloatingLabel label="Отдясно (mm)">
                                            <Form.Control
                                                type="number"
                                                step="1"
                                                name="x_space"
                                                value={Number(state.data.x_space)}
                                                placeholder="Отдясно (mm)"
                                                onChange={(e) => handleInputChange(e)}
                                                isInvalid={Boolean(validations && validations.x_space)}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {validations?.x_space && (validations.x_space[0] || validations.x_space)}
                                            </Form.Control.Feedback>
                                        </FloatingLabel>
                                    </Col>
                                    <Col>

                                    </Col>
                                </Row>
                            </Tab>

                            {/* <Tab eventKey="preview" title="Визуализация" tabClassName={''}>
                                <Alert>
                                    Данните са примерни!
                                </Alert>

                                <div style={{ overflow: 'auto' }}>
                                    <PDFReader key={getPreviewSrc('label')} url={getPreviewSrc('label')} width={getLabelWidthInPx()} />
                                </div>
                            </Tab> */}
                        </Tabs>
                    </Modal.Body>
                    <Modal.Footer style={{ justifyContent: 'space-between' }}>
                        <Button variant="primary" onClick={toggleGrid}>
                            {state.grid ? 'Скрий мрежа' : 'Покажи мрежа'}
                        </Button>
                        <div>
                            <Button variant="secondary" onClick={handleClose} style={{ marginRight: '5px' }}>
                                Отказ
                            </Button>
                            <SaveButton
                                loading={state.loading}
                                className="save"
                            />
                        </div>
                    </Modal.Footer>
                </form>
            </Modal>
        </>
    )
}

export default forwardRef(AddOrEdit);
